<!-- app.component.html -->
<div class="main-container" style="position: relative;">
  <!-- Always display the main container with background -->
  <ng-container *ngIf="initialized && navigationService.getCurrentPage() | async as currentPage">
    <app-success *ngIf="currentPage === 'success'"></app-success>
    <app-selection *ngIf="currentPage === 'selection'"></app-selection>
    <app-checkout *ngIf="currentPage === 'checkout'"></app-checkout>
    <app-stripe *ngIf="currentPage === 'stripe'"></app-stripe>
  </ng-container>

  <!-- Overlay the loading indicator if loading -->
  <app-loading *ngIf="isLoading$ | async"></app-loading>
</div>
